import { render, staticRenderFns } from "./CollectionUnitsHorizontal.vue?vue&type=template&id=7b36da88"
import script from "./CollectionUnitsHorizontal.vue?vue&type=script&lang=js"
export * from "./CollectionUnitsHorizontal.vue?vue&type=script&lang=js"
import style0 from "./CollectionUnitsHorizontal.vue?vue&type=style&index=0&id=7b36da88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports